import { SettingsMediaImage, Settings, WidgetData } from "./data"
import { WpMediaImage, loadImage } from "./wp-media-image"
import { Widget } from "./widget"

export type BasicGalleryData = WidgetData & {
  settings: Settings & {
    wp_gallery?: Array<SettingsMediaImage>,
    thumbnail_size: string,
    gallery_columns: string,
    gallery_link: string,
    gallery_rand?: string,
  },
  widgetType: "image-gallery"
}

export class BasicGalleryWidget extends Widget {
  images: Array<WpMediaImage>
  columns: number
  /* TODO imageSize, orderBy */

  constructor(data: BasicGalleryData) {
    super(data);
    if (data.settings.wp_gallery) {
      this.images = data.settings.wp_gallery.map(loadImage);
    } else {
      this.images = [];
    }
    this.columns = parseInt(data.settings.gallery_columns);
  }
}
